import { supabase } from '../../utils/supabaseClient';

const toDb = (c) => ({
  customer_id: c.customerId,
  customer_name: c.customerName,
  address: c.address || null,
  email: c.email || null,
  mobile: c.mobile || null,
  gst_no: c.gstNo || null,
  customer_state: c.customerState || 'same',
  fuel_charge: c.fuelCharge || 0,
  royalty_charge: c.royaltyCharge || 0,
  gst_percent: c.gstPercent || 0,
});

export async function listCustomers(userId) {
  const { data, error } = await supabase
    .from('customers')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function createCustomer(userId, customer) {
  const payload = { user_id: userId, ...toDb(customer) };
  const { data, error } = await supabase
    .from('customers')
    .insert(payload)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function updateCustomer(userId, id, customer) {
  const payload = toDb(customer);
  const { data, error } = await supabase
    .from('customers')
    .update(payload)
    .eq('id', id)
    .eq('user_id', userId)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function deleteCustomer(userId, id) {
  const { error } = await supabase
    .from('customers')
    .delete()
    .eq('id', id)
    .eq('user_id', userId);
  if (error) throw error;
}

export async function getTotalCustomers(userId) {
  const { count, error } = await supabase
    .from('customers')
    .select('*', { count: 'exact', head: true })
    .eq('user_id', userId);
  
  if (error) throw error;
  return count || 0;
}


/**
 * Check if a customer_id already exists for the user (case-insensitive)
 */
export async function customerIdExists(userId, customerId) {
  if (!customerId) return false;
  const { data, error } = await supabase
    .from('customers')
    .select('id')
    .eq('user_id', userId)
    .ilike('customer_id', customerId)
    .limit(1);
  if (error) throw error;
  return !!(data && data.length > 0);
}

/**
 * Search customers by "customer_id" prefix (case-insensitive)
 * Returns limited rows ordered by customer_id
 */
export async function searchCustomersByIdPrefix(userId, prefix, limit = 10) {
  if (!prefix) return [];
  const { data, error } = await supabase
    .from('customers')
    .select('*')
    .eq('user_id', userId)
    .ilike('customer_id', `${prefix}%`)
    .order('customer_id', { ascending: true })
    .limit(limit);
  if (error) throw error;
  return data || [];
}


